export enum Action {
    EMAIL = 'email',
    SMS = 'sms',
    BOTH = 'both'    
}